import React from 'react';
import { Link } from 'react-router-dom';

function EmptyState({ icon, title, description, actionLabel, onAction, actionTo }) {
  const ActionButton = () => {
    const buttonClasses =
      'inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white text-body-sm font-semibold rounded-xl hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500/40 focus:ring-offset-2 transition-colors duration-200';

    if (actionTo) {
      return (
        <Link to={actionTo} className={buttonClasses}>
          {actionLabel}
        </Link>
      );
    }

    if (onAction) {
      return (
        <button type="button" onClick={onAction} className={buttonClasses}>
          {actionLabel}
        </button>
      );
    }

    return null;
  };

  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      {icon && (
        <div className="w-16 h-16 rounded-2xl bg-primary-50 text-primary-500 flex items-center justify-center mb-5">
          {icon}
        </div>
      )}

      {title && (
        <h3 className="text-h3 text-surface-900 mb-2">{title}</h3>
      )}

      {description && (
        <p className="text-body text-surface-500 max-w-sm mb-6">{description}</p>
      )}

      {actionLabel && <ActionButton />}
    </div>
  );
}

export default EmptyState;
